let routes = [
  {
    path: '/creation-de-compte',
    component: () => import('../views/CreationDeCompte.vue')
  },
  {
    path: "/demande",
    component: () => import('../views/Demande.vue')
  },
]

export default routes;


